import { Injectable } from "@angular/core";
import swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class Sweetalert2Service {
  constructor() {}

  withError(title, message, showCancelButton = true): void {
    swal.fire({
      icon: "error",
      title: title || "",
      html: message || "",
      heightAuto: false,
      showConfirmButton: true,
      confirmButtonText: "ตกลง",
      confirmButtonColor: "#3085d6",
      showCancelButton,
    });
  }

  withSuccess(title, message, showCancelButton = false): void {
    swal.fire({
      icon: "success",
      title: title || "",
      html: message || "",
      heightAuto: false,
      confirmButtonText: "ตกลง",
      confirmButtonColor: "#3085d6",
      showCancelButton,
    });
  }
  withWarning(title, message, showCancelButton = true): void {
    swal.fire({
      icon: `warning`,
      title: title || "",
      html: message || "",
      heightAuto: false,
      showCancelButton,
      confirmButtonText: "ตกลง",
      confirmButtonColor: "#3085d6",
    });
  }

  withConfirm(title, message, confirmButtonText = "ตกลง", cancelButtonText = "ยกเลิก"): Promise<any> {
    return new Promise((resolve, reject) => {
      swal
        .fire({
          icon: "warning",
          title: title || "",
          html: message,
          heightAuto: false,
          showCancelButton: true,
          confirmButtonText: confirmButtonText,
          cancelButtonText: cancelButtonText,
          confirmButtonColor: "#3085d6",
        })
        .then((result) => {
          if (result.value) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => reject(err));
    });
  }

  withQuestion(title, message): Promise<any> {
    return new Promise((resolve, reject) => {
      swal
        .fire({
          icon: "question",
          title: title || "",
          html: message,
          heightAuto: false,
          showCancelButton: true,
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          confirmButtonColor: "#3085d6",
        })
        .then((result) => {
          if (result.value) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => reject(err));
    });
  }

  withAccept(
    title,
    message,
    txtbtn_ok,
    txtbtn_cancel,
    show_cancel: boolean
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      swal
        .fire({
          title: title || "",
          html: message,
          heightAuto: false,
          showCancelButton: show_cancel,
          confirmButtonText: txtbtn_ok,
          cancelButtonText: txtbtn_cancel,
          confirmButtonColor: "#3085d6",
        })
        .then((result) => {
          if (result.value) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => reject(err));
    });
  }

  withInput(
    title = "",
    html = "",
    required = false,
    confirmBtn = "ตกลง",
    cancelBtn = "ยกเลิก"
  ) {
    return new Promise((resolve, reject) => {
      swal
        .fire({
          title: `${title}`,
          html: `<p style="text-align: left;margin-top: 0px;">${html}${
            required ? "*" : ""
          }</p>`,
          input: "text",
          inputAttributes: {
            autocapitalize: "off",
            maxlength: "250",
          },
          showCancelButton: true,
          confirmButtonText: confirmBtn,
          cancelButtonText: cancelBtn,
          showLoaderOnConfirm: true,
          preConfirm: async (val) => {
            if (val || !required) {
              return val;
            } else {
              swal.showValidationMessage(`กรุณากรอก${html}`);
            }
          },
          allowOutsideClick: () => !swal.isLoading(),
          confirmButtonColor: "#3085d6",
        })
        .then((result: any) => {
          const { value } = result;
          resolve(value);
        });
    });
  }

  withMultipleButton(
    title = "",
    confirmTxt = "",
    denyTxt = "",
    cancelTxt = "ยกเลิก",
    confirmColor = "rgb(22 163 74)",
    denyColor = "#d33"
  ) {
    return new Promise((resolve, reject) => {
      swal
        .fire({
          icon: "question",
          title: title,
          showDenyButton: true,
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: confirmTxt,
          denyButtonText: denyTxt,
          cancelButtonText: cancelTxt,
          customClass: {
            actions: "my-actions",
            cancelButton: "order-1 right-gap",
            confirmButton: "order-3",
            denyButton: "order-2",
          },
          confirmButtonColor: confirmColor,
          denyButtonColor: denyColor,
        })
        .then((result) => {
          if (result.isConfirmed) {
            resolve("confirmed");
          } else if (result.isDenied) {
            resolve("denied");
          } else {
            resolve(false);
          }
        })
        .catch((err) => reject(err));
    });
  }

  dialogInstallmentDetail() {
    return new Promise((resolve, reject) => {
      swal.fire({
        title: 'รายละเอียดงวดการผ่อน',
        html:
          '<input id="swal-input1" class="swal2-input" type="number" placeholder="งวดการผ่อน">' +
          '<input id="swal-input2" class="swal2-input" type="number" placeholder="งวดสิ้นสุด">' +
          '<input id="swal-input3" class="swal2-input" type="number" placeholder="จำนวนเงิน">',
        focusConfirm: false,
        preConfirm: () => {
          const input1 = document.getElementById('swal-input1') as HTMLInputElement | null;
          const input2 = document.getElementById('swal-input2') as HTMLInputElement | null;
          const input3 = document.getElementById('swal-input3') as HTMLInputElement | null;
          return {
            installmentStart: input1.value !== null ? +input1.value : null,
            installmentEnd: input2.value !== null ? +input2.value : null,
            installmentAmount: input3.value !== null ? +input3.value : null,
          }
        },
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "เพิ่ม",
        cancelButtonText: "ยกเลิก",
      }).then(result => {
        if (result.isConfirmed) {
          resolve({
            ...result.value,
            isConfirm: true
          });
        } else {
          resolve({
            installmentStart: null,
            installmentEnd: null,
            installmentAmount: null,
            isConfirm: false
          });
        }

      })
      .catch((err) => reject(err));;
    });

  }
}
